import { render, staticRenderFns } from "./ProductDetailDigitalCatalog.vue?vue&type=template&id=7f227456&scoped=true"
import script from "./ProductDetailDigitalCatalog.vue?vue&type=script&lang=js"
export * from "./ProductDetailDigitalCatalog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f227456",
  null
  
)

export default component.exports